import { SelectedOption } from "./selectedOption.model";

export const LANGUAGE_TYPE_OPTIONS: SelectedOption[] = [
    {
        value: LanguageType.Serbian,
        label: 'Srpski'
    },
    {
        value: LanguageType.Bulgarian,
        label: 'Bugarski'
    },
    {
        value: LanguageType.Romanian,
        label: 'Rumunski'
    },
    {
        value: LanguageType.Macedonian,
        label: 'Makedonski'
    }
];

export const enum LanguageType {
    Serbian = 1,
    Macedonian = 2,
    Romanian = 3,
    Bulgarian = 4
}
